import { Action } from '@/_core/fluxstore/types';
import { ManageProductsState } from '../types';
import { useManageProductsStore } from '../useModule';
import * as productsStoreModule from '@/store/main/Products';

const { registerMiddleware, registerReducer } = useManageProductsStore();

export class NewProductAdded extends Action<ManageProductsState> {
    public static ACTION_TYPE = 'NewProductAdded';

    public constructor(public id: string, public name: string, public slug: string) {
        super(NewProductAdded.ACTION_TYPE);
    }
}

const addToNavbarMiddleware = async (state: ManageProductsState, action: NewProductAdded): Promise<boolean> => {
    const otherStore = productsStoreModule.useProductsStore();
    if (otherStore.state.isInitialized) {
        otherStore.dispatch(new productsStoreModule.ProductCreated(action.id, action.slug, action.name));
    }

    return true;
};

const reducer = (state: ManageProductsState, action: NewProductAdded): void => {
    state.products.push({
        id: action.id,
        name: action.name,
        slug: action.slug,
        guestIds: [],
        memberIds: [initAppData.currentWs.workspaceMemberShortId],
    });
};

//@ts-ignore
registerMiddleware(NewProductAdded.ACTION_TYPE, addToNavbarMiddleware);

//@ts-ignore
registerReducer(NewProductAdded.ACTION_TYPE, reducer);
